import {
  matchPath,
  Route,
  Routes,
  useLocation
} from "react-router";
import Top from "./Top/Top";
import Company from "./Company/Company";
import Service from "./Service/Service";
import News from "./News/News";
import NewsDetail from "./News/NewsDetail/NewsDetail";
import Contact from "./Contact/Contact";
import Recruit from "./Recruit/Recruit";
import NotFound from "./NotFound/NotFound";
import Software from "./Service/Software/Software";
import System from "./Service/System/System";
import { useEffect } from "react";
import { PAGE } from "../constants/page";
import { Helmet } from "react-helmet";
import Security from "./Security/Security";

interface Props {
  children?: React.ReactElement<unknown>;
}

export default function AppRoutes(props: Props) {
  const { pathname } = useLocation()

  useEffect(() => {
    // アンカーリンクがない場合
    if (!window.location.hash) {
      // ページ遷移時にトップへスクロール
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }, [pathname])

  // URLからページ情報を取得
  const matchedPage = pathname === PAGE.TOP.PATH ?
    // トップページの場合はtitleを設定しない
    {
      PATH: '/',
      NAME: '',
      TEXT: '',
      DESC: PAGE.TOP.DESC
    }
    :
    // `:id`などの動的ルートも考慮してマッチ
    Object.values(PAGE).find((page) => matchPath({ path: page.PATH, end: true }, pathname))

  return (
    <>
      <Helmet>
        <title>
          {`${matchedPage?.NAME} ${matchedPage?.TEXT}${matchedPage?.NAME && ' - '}${process.env.REACT_APP_NAME}`}
        </title>
        <meta name="description" content={matchedPage?.DESC} />
      </Helmet>
      <Routes>
        <Route path={PAGE.TOP.PATH} element={<Top />} />
        <Route path={PAGE.SERVICE.PATH} element={<Service />} />
        <Route path={PAGE.SYSTEM.PATH} element={<System />} />
        <Route path={PAGE.SOFTWARE.PATH} element={<Software />} />
        <Route path={PAGE.NEWS.PATH} element={<News />} />
        <Route path={PAGE.NEWS_DETAIL.PATH} element={<NewsDetail />} />
        <Route path={PAGE.RECRUIT.PATH} element={<Recruit />} />
        <Route path={PAGE.COMPANY.PATH} element={<Company />} />
        <Route path={PAGE.CONTACT.PATH} element={<Contact />} />
        <Route path={PAGE.SECURITY.PATH} element={<Security />} />
        <Route path={PAGE.ERROR.PATH} element={<NotFound />} />
      </Routes>
    </>
  )
}
